import { ecsApi, CreateHomeSecurityResponse, CreateHomeSecurityPayload } from '@services';

export const homeSecurityApi = ecsApi.injectEndpoints({
    endpoints: (builder) => ({
        createHomeSecurity: builder.mutation<CreateHomeSecurityResponse, CreateHomeSecurityPayload>({
            query: (homeSecurity) => ({
                url: '/security-welcome',
                method: 'POST',
                body: homeSecurity
            })
        })
    })
});

export const { useCreateHomeSecurityMutation } = homeSecurityApi;
